export function formatAmount(num, fixed = 2) {
    if (!num) { return 0 }
    let numCount = num.toString().split(".");
    let numString = numCount[1] ? numCount[1].toString().substr(0, fixed + 1) : "";
    let numPoint = numString ? ("." + Math.round(numString / 10)) : "";

    const NumCountVal = (numCount[0] + '').replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,') + numPoint;
    return typeof (num) === "number" && isNaN(num) ? 0 : NumCountVal;
}

export function formatNumber(data, precision = 2, removeZero = false, commas = true) {
    if (!data) {
        const zero = 0;
        if (removeZero) {
            return zero.toFixed(0);
        } else {
            return zero.toFixed(precision);
        }
    }

    //最多允許 precision 位小數
    const reg = new RegExp(`(\\.\\d{${precision}})\\d+$`);
    let number = data && data.toString().replace(/[^\d.]/g, '').replace(reg, '$1') || '';

    //若小數位數不足，補上對應的零
    number = parseFloat(number).toFixed(precision);
    
    const parts = String(number).split(".");
    if (commas) {
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    const formattedNum = precision ? parts.join(".") : parts[0];
    if (!removeZero) {
        return formattedNum;
    } else {
        return formattedNum.replace(/(\.\d*[1-9])0*$|(\.\d*0)$|^0\.0*$/g, "$1");
    }
}

export function getInputVal(v) {
    return typeof v === "object" ? (v.target ? v.target.value : "") : v;
}

// 过滤支付渠道
export function availableMethodsFilter (currAvailableMethods) {
    return Array.isArray(currAvailableMethods) ? currAvailableMethods.filter((v) => (v.methodCode !== "DEFAULT")) : [];
}

export function setFormData(getForm, timer, data) {
    const SetData = function() {
        const FORM = getForm();
        console.log("FORM:::", FORM)
        if (typeof FORM === "object" && FORM !== null) {
            console.log(FORM, "FORM")
            FORM.setFieldsValue(data);
            return true;
        } else {
            return false;
        }
    }
    
    timer = setInterval(() => {
        console.log("重复执行 SetFormData，测试使用，如太多，则需优化。（理论上来说此处不应该执行到）");
        SetData() && clearInterval(timer);
    }, 100);
}

export function formatSeconds(value) {
    var seconds = parseInt(value); // 秒
    var minute = 0; // 分
    var hour = 0; // 小时
    var day = 0; // 天

    if (seconds > 60) {
        minute = parseInt(seconds / 60);
        seconds = parseInt(seconds % 60);
        if (minute > 60) {
            hour = parseInt(minute / 60);
            minute = parseInt(minute % 60);
            if (hour > 24) {
                day = parseInt(hour / 24);
                hour = parseInt(hour % 24);
            }
        }
    }

    return [day, hour, minute, seconds];
}

export function getMaskingLen(str, offset) {
    let maskString = "";
    if (typeof str === "string" || typeof str === "number") {
        if (typeof str === "number") {
            str = { length: str }
        }
        for(let i = 0; i < str.length; i++) {
            maskString += "*";
        }
        return offset ? (getMaskingLen(str.length + offset) + str.substr(offset)) : maskString;
    } else {
        return "";
    }
}

// 浮点数计算
export function mul(a, b) {
    if (!a || !b) {
        return "";
    }
    var c = 0,
        d = a.toString(),
        e = b.toString();
    try {
        c += d.split(".")[1].length;
    } catch (f) { }
    try {
        c += e.split(".")[1].length;
    } catch (f) { }
    return (Number(d.replace(".", "")) * Number(e.replace(".", "")) / Math.pow(10, c)).toFixed(5);
}

export function div(a, b) {
    var c, d, e = 0,
        f = 0;
    try {
        e = a.toString().split(".")[1].length;
    } catch (g) { }
    try {
        f = b.toString().split(".")[1].length;
    } catch (g) { }
    return c = Number(a.toString().replace(".", "")), d = Number(b.toString().replace(".", "")), mul(c / d, Math.pow(10, f - e));
}

export function add(a, b) {
    var c, d, e;
    try {
        c = a.toString().split(".")[1].length;
    } catch (f) {
        c = 0;
    }
    try {
        d = b.toString().split(".")[1].length;
    } catch (f) {
        d = 0;
    }
    return e = Math.pow(10, Math.max(c, d)), (mul(a, e) + mul(b, e)) / e;
}

export function sub(a, b) {
    var c, d, e;
    try {
        c = a.toString().split(".")[1].length;
    } catch (f) {
        c = 0;
    }
    try {
        d = b.toString().split(".")[1].length;
    } catch (f) {
        d = 0;
    }
    return e = Math.pow(10, Math.max(c, d)), (mul(a, e) - mul(b, e)) / e;
}


export class SetFormStaticData {
    constructor() {
        this.data;
    }
    getData = () => (
        this.data
    )
    setData = (name, val) => {
        typeof this.data === "undefined" ? (this.data = { [name]: val }) : this.data[name] = val;
    }
}